import { IsolatesCreate } from "./IsolatesCreate";
import { IsolatesList } from "./IsolatesList";
import { IsolatesShow } from "./IsolatesShow";
import { IsolatesEdit } from "./IsolatesEdit";

export const isolates = {
  create: IsolatesCreate,
  list: IsolatesList,
  show: IsolatesShow,
  edit: IsolatesEdit,
};
